module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.ad5795be.ttf";